import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { isUnknownPlatform } from "components/TableDetails/DeviceDetails/Details/functions";
import TableContext from "context/table/tableContext";

import { FinalStepButtonsProps } from "../types";

const FinalStepButtons = ({
    isLoading,
    isLimitReached,
    unlockKey,
    lockCode,
    onSecondaryBtnClick
}: FinalStepButtonsProps) => {
    const {
        detailsData: { model_platform }
    } = useContext(TableContext);

    const { t } = useTranslation();

    const getSecondaryBtnText = () => {
        const isBackBtn = isUnknownPlatform(model_platform) || unlockKey;

        return t(`Button##${isBackBtn ? "back" : "close"}`);
    };

    return (
        <>
            <Button
                fullWidth
                color={BUTTON_COLORS.Secondary}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.TextOnly}
                disabled={isLoading}
                onClick={onSecondaryBtnClick}
            >
                {getSecondaryBtnText()}
            </Button>

            {!unlockKey && (
                <Button
                    fullWidth
                    color={BUTTON_COLORS.Primary}
                    size={BUTTON_SIZES.Normal}
                    variant={BUTTON_VARIANTS.TextOnly}
                    type="submit"
                    isLoading={isLoading}
                    disabled={isLimitReached || lockCode.length === 0}
                >
                    {t("Button##generate")}
                </Button>
            )}
        </>
    );
};

export { FinalStepButtons };
